import styles from './style.postcss';
import React from 'react';
import { Tooltip, Button, Icon, testClass } from 'omni-common-ui';
import { AttendanceStatus } from 'data/SessionsAttendance/status';
import classnames from 'classnames';
import PropTypes from 'prop-types';

const MarkAttendanceButtons = (props) => {
  const markPresentClassName = classnames(
    styles.MarkAttendanceButtons_button,
    testClass('mark-present-btn')
  );
  const markAbsentClassName = classnames(
    styles.MarkAttendanceButtons_button,
    testClass('mark-absent-btn')
  );
  const markLateClassName = classnames(
    styles.MarkAttendanceButtons_button,
    testClass('mark-late-btn')
  );
  return <div className={styles.MarkAttendanceButtons}>
    <Tooltip text="Present" className={styles.MarkAttendanceButtons_buttonContainer}>
      <Button className={markPresentClassName}
          onClick={() => props.onMarkPresent()}
          autoWidth
          active={props.status === AttendanceStatus.present}>
        <Icon id="tick" />
      </Button>
    </Tooltip>
    <Tooltip text="Absent" className={styles.MarkAttendanceButtons_buttonContainer}>
      <Button className={markAbsentClassName}
          onClick={() => props.onMarkAbsent()}
          autoWidth
          active={props.status === AttendanceStatus.absent}>
        <Icon id="cross" />
      </Button>
    </Tooltip>
    <Tooltip text="Late" className={styles.MarkAttendanceButtons_buttonContainer}>
      <Button className={markLateClassName}
          onClick={() => props.onMarkLate()}
          autoWidth
          active={props.status === AttendanceStatus.late}>
        <Icon id="clock" />
      </Button>
    </Tooltip>
    {renderNotApplicable()}
  </div>;

  function renderNotApplicable() {
    if (props.canSeeNotApplicable !== true) {
      return null;
    }

    return <Tooltip text="Not Applicable" className={styles.MarkAttendanceButtons_buttonContainer}>
      <Button className={classnames(styles.MarkAttendanceButtons_button,
        styles.__na,
        { [styles.__highlighted]: props.status === AttendanceStatus.notApplicable })}
          onClick={() => props.onMarkNA()}
          autoWidth />
    </Tooltip>;
  }
};

MarkAttendanceButtons.propTypes = {
  status: PropTypes.oneOf(Object.values(AttendanceStatus)),
  onMarkPresent: PropTypes.func.isRequired,
  onMarkAbsent: PropTypes.func.isRequired,
  onMarkLate: PropTypes.func.isRequired,
  onMarkNA: PropTypes.func,
  canSeeNotApplicable: PropTypes.bool,
};

export default MarkAttendanceButtons;



// WEBPACK FOOTER //
// ./containers/Group/Attendance/MarkAttendance/MarkAttendanceButtons/component.jsx